export default "__VITE_ASSET__Deg$jv1Y__"